(function () {
  function initBannerLinks() {
    document.querySelectorAll('.new-custom-banner[data-banner-link]').forEach(function (banner) {
      var href = banner.dataset.bannerLink;
      if (!href) return;

      banner.classList.add('new-custom-banner--has-link');

      banner.addEventListener('click', function (e) {
        // If the user clicked a native <a> or <button> inside the banner, let it handle the event
        var interactive = e.target.closest('a[href], button');
        if (interactive) return;

        window.location.assign(href);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBannerLinks);
  } else {
    initBannerLinks();
  }
})();
